package com.anjuros.website.templates.template1.modules

import com.anjuros.website.components.shared.CompanyDetailsType
import com.anjuros.website.templates.template1.util.ResKey
import com.anjuros.website.templates.template1.util.Template1CompanyDetails
import com.anjuros.website.templates.template1.util.Template1Constants.CLIENTS_ADDRESS_MAP
import com.anjuros.website.templates.template1.util.Template1Constants.CLIENTS_EMAIL
import com.anjuros.website.templates.template1.util.Template1Constants.CLIENTS_PHONE


enum class Template1Contact(
    val icon: String,
    val title: ResKey,
    val text: CompanyDetailsType,
    val path:String,
){
    Template1Contact1(
        icon = "template1_contact1.svg",
        title = ResKey.TEMPLATE1_CONTACT_ADDRESS_TITLE,
        text = Template1CompanyDetails.CLIENTS_COMPANY_ADDRESS1_INFO,
        path = CLIENTS_ADDRESS_MAP
    ),



    Template1Contact2(

    icon = "template1_contact2.svg",
    title = ResKey.TEMPLATE1_CONTACT_PHONE_TITLE,
    text = Template1CompanyDetails.CLIENTS_PHONE_INFO,
        path = "tel:$CLIENTS_PHONE"
    ),



    Template1Contact3(

    icon = "template1_contact3.svg",
    title = ResKey.TEMPLATE1_CONTACT_EMAIL_TITLE,
    text = Template1CompanyDetails.CLIENTS_EMAIL_INFO,
        path = "mailto:$CLIENTS_EMAIL"
    )

}